import React from 'react'
import { StyleSheet, Dimensions } from "react-native";
import "../../../App.scss";

const actualWidth = Dimensions.get("screen").width;

export const styles = StyleSheet.create({
  container: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "var(--mandg-alt-background)",
  },
  body: {
    height: actualWidth > 600 ? "70%" : "73%",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  bodyHeader: {
    justifyContent: "center",
    alignItems: "center",
    marginBottom: actualWidth < 600 ? 10 : 0,
  },
  headerText: {
    textAlign: "center",
    fontFamily: "Infra",
    fontSize: 28,
    fontWeight: "var(--font-weight-semi-bold)",
    color: "#2f2f2f",
    lineHeight: 32,
  },
  bodyTextContainer: {
    justifyContent: "center",
    alignItems: "center",
    width: actualWidth > 900 ? "40%" : actualWidth > 600 ? "78%" : "90%",
    alignSelf: "center",
    marginVertical: "2%",
  },
  bodyText: {
    textAlign: "center",
    fontFamily: "Infra",
    fontSize: 20,
    fontWeight: "var(--font-weight-light)",
    color: "#2f2f2f",
    lineHeight: 28,
    fontStyle: "normal",
  },
  button: {
    height: 40,
    width: 115,
    backgroundColor: "#2f2f2f",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonText: {
    textAlign: "center",
    fontFamily: "Infra",
    fontSize: 16,
    fontWeight: "var(--font-weight-semi-bold)",
    color: "#ffffff",
    lineHeight: 24,
  },
  footer: {
    height: "15%",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: actualWidth < 600 ? 14 : 0,
  },

  animatedCircleStyle: {
    backgroundColor: "#FFFDD0",
    width: 10,
    height: 10,
    borderRadius: 5,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: [{ translateX: -5 }, { translateY: -5 }],
    zIndex: 99,
  },
});
